import { Checkbox, FormControl, FormControlLabel, FormHelperText } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { PREMISES_TYPES } from '../../constants';
import React from 'react';
import { styles } from '../../styles';

export const PremisesTypesCheckboxGroup = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors.premisesTypesInConflictZone;

  return (
    <FormControl
      error={!!error}
      sx={styles.checkboxContainer}
      fullWidth
      data-name="premisesTypesInConflictZone"
    >
      <Controller
        name="premisesTypesInConflictZone"
        control={control}
        defaultValue={[]}
        render={({ field }) => {
          const value: string[] = field.value ?? [];

          const toggle = (label: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
            const checked = e.target.checked;
            field.onChange(checked ? [...value, label] : value.filter((item) => item !== label));
          };

          return (
            <>
              {PREMISES_TYPES.map((label) => (
                <FormControlLabel
                  key={label}
                  label={label}
                  control={<Checkbox checked={value?.includes(label)} onChange={toggle(label)} />}
                />
              ))}
            </>
          );
        }}
      />

      <FormHelperText sx={{ top: '100%' }}>
        {(error as { message?: string })?.message}
      </FormHelperText>
    </FormControl>
  );
};
